import { useForm, usePage } from "@inertiajs/react";
import { useEffect, useState } from "react";

export default function Header() {
    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
    const { post, processing } = useForm();
    const {
        data: passwordData,
        setData: setPasswordData,
        put: putPassword,
        processing: passwordProcessing,
        errors: passwordErrors,
        reset: resetPasswordForm,
        clearErrors: clearPasswordErrors,
        recentlySuccessful: passwordRecentlySuccessful,
    } = useForm({
        current_password: "",
        password: "",
        password_confirmation: "",
    });

    function signOut() {
        if (processing) return;

        post('/logout', {
            preserveScroll: true,
            onError: () => {
                window.location.href = '/login';
            },
        });
    }

    function openPasswordModal() {
        clearPasswordErrors();
        setIsPasswordModalOpen(true);
    }

    function closePasswordModal() {
        setIsPasswordModalOpen(false);
        clearPasswordErrors();
        resetPasswordForm();
    }

    function submitPasswordUpdate(event) {
        event.preventDefault();
        putPassword("/profile/password", {
            preserveScroll: true,
            onSuccess: () => {
                closePasswordModal();
            },
        });
    }

    const { url, props } = usePage();
    const pathname = url.split("?")[0];
    const auth = props?.auth ?? {};
    const roles = Array.isArray(auth.roles) ? auth.roles : [];
    const isMemberLoggedIn = Boolean(auth.user) && roles.includes("member");
    const mustResetPassword = Boolean(auth.must_reset_password);
    const displayName = auth?.user?.name ?? "James Collison";

    useEffect(() => {
        if (isMemberLoggedIn && mustResetPassword) {
            clearPasswordErrors();
            setIsPasswordModalOpen(true);
        }
    }, [clearPasswordErrors, isMemberLoggedIn, mustResetPassword]);

    const isActive = (href) => (href === "/" ? pathname === "/" : pathname.startsWith(href));
    const navClass = (href) =>
        `relative inline-block text-foreground focus:outline-hidden ${isActive(href) ? "nav-active" : ""}`;

    return <>
        <header className="flex flex-wrap lg:justify-start lg:flex-nowrap z-50 w-full py-7 bg-navbar">
            <nav className="relative max-w-7xl w-full flex flex-wrap lg:grid lg:grid-cols-12 basis-full items-center px-4 md:px-6 lg:px-8 mx-auto">
                <div className="lg:col-span-3 flex items-center">

                    <a className="flex-none rounded-xl text-4xl inline-block font-semibold focus:outline-hidden focus:opacity-80 text-foreground" href="/" aria-label="nitnotstore">
                        nitnot.store
                    </a>
                </div>


                <div className="flex items-center gap-x-1 lg:gap-x-2 ms-auto py-1 lg:ps-6 lg:order-3 lg:col-span-3">
                    <div className={`button-group ${isMemberLoggedIn ? "hidden" : "flex"} items-center gap-x-2`}>
                        <a
                            href="/login"
                            className="py-2 px-3 inline-flex items-center justify-center gap-x-2 text-sm font-medium rounded-xl border border-layer-line bg-layer text-layer-foreground hover:bg-layer-hover focus:outline-hidden focus:bg-layer-focus transition"
                        >
                            Masuk
                        </a>
                        <a
                            href="/sign-up"
                            className="py-2 px-3 inline-flex items-center justify-center gap-x-2 text-sm font-medium rounded-xl border border-primary-line bg-primary text-primary-foreground hover:bg-primary-hover focus:outline-hidden focus:bg-primary-focus transition shadow-2xs"
                        >
                            Daftar Reseller
                        </a>
                    </div>
                    <div className={`user-login h-9.5 ${isMemberLoggedIn ? "flex" : "hidden"} justify-end items-center gap-x-2`}>
                        <div className="hs-dropdown  inline-flex   [--strategy:absolute] [--auto-close:inside] [--placement:bottom-right] relative text-start">
                            <button id="hs-dnad" type="button" className="inline-flex shrink-0 items-center gap-x-1.5 text-start rounded-full focus:outline-hidden" aria-haspopup="menu" aria-expanded="false" aria-label="Dropdown">
                                <img className="shrink-0 size-9.5 lg:size-8 rounded-full" src="https://images.unsplash.com/photo-1659482633369-9fe69af50bfb?ixlib=rb-4.0.3&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=facearea&amp;facepad=3&amp;w=320&amp;h=320&amp;q=80" alt="Avatar" />
                                <span className="grow hidden lg:block">
                                    <span className="text-sm font-medium text-foreground">
                                        {displayName}
                                    </span>
                                </span>
                            </button>


                            <div className="hs-dropdown-menu hs-dropdown-open:opacity-100 w-60 transition-[opacity,margin] duration opacity-0 hidden z-20 bg-dropdown border border-dropdown-line rounded-xl shadow-xl" role="menu" aria-orientation="vertical" aria-labelledby="hs-dnad" tabIndex={-1}>
                                <div className="p-1 border-b border-dropdown-divider">
                                    <a className="py-2 px-3 flex items-center gap-x-3 rounded-lg text-sm text-dropdown-item-foreground hover:bg-dropdown-item-hover disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-dropdown-item-focus" href="../../pro/dashboard/user-profile-my-profile.html">
                                        <img className="shrink-0 size-8 rounded-full" src="https://images.unsplash.com/photo-1659482633369-9fe69af50bfb?ixlib=rb-4.0.3&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=facearea&amp;facepad=3&amp;w=320&amp;h=320&amp;q=80" alt="Avatar" />

                                        <div className="grow">
                                            <span className="text-sm font-semibold text-foreground">
                                                {displayName}
                                            </span>
                                        </div>
                                    </a>
                                </div>
                                <div className="p-1">
                                    <button type="button" onClick={signOut} className="flex items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-dropdown-item-foreground hover:bg-dropdown-item-hover disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-dropdown-item-focus" href="#">
                                        Keluar
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className="lg:hidden">
                        <button type="button" className="hs-collapse-toggle size-9.5 flex justify-center items-center text-sm font-semibold rounded-xl bg-layer border border-layer-line text-layer-foreground hover:bg-layer-hover focus:outline-hidden focus:bg-layer-focus disabled:opacity-50 disabled:pointer-events-none" id="hs-pro-hcail-collapse" aria-expanded="false" aria-controls="hs-pro-hcail" aria-label="Toggle navigation" data-hs-collapse="#hs-pro-hcail">
                            <svg className="hs-collapse-open:hidden shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="3" x2="21" y1="6" y2="6"></line>
                                <line x1="3" x2="21" y1="12" y2="12"></line>
                                <line x1="3" x2="21" y1="18" y2="18"></line>
                            </svg>
                            <svg className="hs-collapse-open:block hidden shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M18 6 6 18"></path>
                                <path d="m6 6 12 12"></path>
                            </svg>
                        </button>
                    </div>
                </div>



                <div id="hs-pro-hcail" className="hs-collapse hidden overflow-hidden transition-all duration-300 basis-full grow lg:block lg:w-auto lg:basis-auto lg:order-2 lg:col-span-6" aria-labelledby="hs-pro-hcail-collapse" role="region">
                    <div className="flex flex-col gap-y-4 gap-x-0 mt-5 lg:flex-row lg:justify-center lg:items-center lg:gap-y-0 lg:gap-x-7 lg:mt-0">
                        <div>
                            <a className={navClass("/")} href="/" aria-current={isActive("/") ? "page" : undefined}>Beranda</a>
                        </div>
                        <div>
                            <a className={navClass("/product")} href="/product" aria-current={isActive("/product") ? "page" : undefined}>Produk</a>
                        </div>
                        <div>
                            <a className={navClass("/sales-order")} href="/sales-order" aria-current={isActive("/sales-order") ? "page" : undefined}>Lacak Pesanan</a>
                        </div>
                        <div>
                            <a className={navClass("/faq")} href="/faq" aria-current={isActive("/faq") ? "page" : undefined}>FAQ</a>
                        </div>                        {isMemberLoggedIn && (
                            <div>
                                <a className={navClass("/profile")} href="/profile" aria-current={isActive("/profile") ? "page" : undefined}>Profil</a>
                            </div>
                        )}
                    </div>
                </div>

            </nav>
        </header>
        {isPasswordModalOpen && (
            <div className="fixed inset-0 z-60 flex items-center justify-center px-4">
                <div
                    className="absolute inset-0 bg-black/50"
                    onClick={mustResetPassword ? undefined : closePasswordModal}
                    aria-hidden="true"
                />
                <div className="relative z-10 w-full max-w-md rounded-xl border border-gray-200 bg-white p-5 shadow-xl dark:border-neutral-700 dark:bg-neutral-800">
                    <div className="mb-4 flex items-center justify-between">
                        <h3 className="text-base font-semibold text-gray-800 dark:text-neutral-200">
                            Ubah Kata Sandi
                        </h3>
                        {!mustResetPassword && (
                            <button
                                type="button"
                                onClick={closePasswordModal}
                                className="rounded-md px-2 py-1 text-sm text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:hover:text-neutral-200"
                            >
                                Tutup
                            </button>
                        )}
                    </div>
                    {mustResetPassword && (
                        <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-700">
                            Silakan ubah kata sandi default Anda sebelum melanjutkan.
                        </div>
                    )}
                    <form className="space-y-3" onSubmit={submitPasswordUpdate}>
                        {!mustResetPassword && (
                            <div>
                                <label htmlFor="header-current-password" className="mb-1 block text-sm font-medium text-gray-700 dark:text-neutral-200">
                                    Kata Sandi Saat Ini
                                </label>
                                <input
                                    id="header-current-password"
                                    type="password"
                                    value={passwordData.current_password}
                                    onChange={(event) => setPasswordData("current_password", event.target.value)}
                                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-800 focus:border-indigo-500 focus:outline-none dark:border-neutral-600 dark:bg-neutral-900 dark:text-neutral-200"
                                />
                                {passwordErrors.current_password && (
                                    <p className="mt-1 text-xs text-red-600">{passwordErrors.current_password}</p>
                                )}
                            </div>
                        )}
                        <div>
                            <label htmlFor="header-new-password" className="mb-1 block text-sm font-medium text-gray-700 dark:text-neutral-200">
                                Kata Sandi Baru
                            </label>
                            <input
                                id="header-new-password"
                                type="password"
                                value={passwordData.password}
                                onChange={(event) => setPasswordData("password", event.target.value)}
                                className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-800 focus:border-indigo-500 focus:outline-none dark:border-neutral-600 dark:bg-neutral-900 dark:text-neutral-200"
                            />
                            {passwordErrors.password && (
                                <p className="mt-1 text-xs text-red-600">{passwordErrors.password}</p>
                            )}
                        </div>
                        <div>
                            <label htmlFor="header-password-confirmation" className="mb-1 block text-sm font-medium text-gray-700 dark:text-neutral-200">
                                Konfirmasi Kata Sandi Baru
                            </label>
                            <input
                                id="header-password-confirmation"
                                type="password"
                                value={passwordData.password_confirmation}
                                onChange={(event) => setPasswordData("password_confirmation", event.target.value)}
                                className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-800 focus:border-indigo-500 focus:outline-none dark:border-neutral-600 dark:bg-neutral-900 dark:text-neutral-200"
                            />
                            {passwordErrors.password_confirmation && (
                                <p className="mt-1 text-xs text-red-600">{passwordErrors.password_confirmation}</p>
                            )}
                        </div>
                        {passwordRecentlySuccessful && (
                            <p className="text-xs text-emerald-600">Kata sandi berhasil diperbarui.</p>
                        )}
                        <div className="flex justify-end gap-2 pt-2">
                            {!mustResetPassword && (
                                <button
                                    type="button"
                                    onClick={closePasswordModal}
                                    className="rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 dark:border-neutral-600 dark:text-neutral-200 dark:hover:bg-neutral-700"
                                >
                                    Batal
                                </button>
                            )}
                            <button
                                type="submit"
                                disabled={passwordProcessing}
                                className="rounded-lg bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-60"
                            >
                                {passwordProcessing ? "Sedang memperbarui..." : "Perbarui Kata Sandi"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        )}
    </>
}
